import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMagnifier24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMagnifier24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.5 11a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-1.688 6.872a9 9 0 1 1 1.06-1.06l2.898 2.898a.75.75 0 1 1-1.06 1.06z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMagnifier24);
